// Equipamentos.js - Arquivo de dados sem usar useState

const equipamentos = [
  {
    id: "SOM01",
    categoria: "SOM",
    nome: 'Caixa de Grave Ativa 18" 1000W \nAttack VRS-1810A',
    preco: 300,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/subwoofer vrs-1810a.jpg",
    descricao:
      "Sinta a potência vibrante que transforma qualquer evento! Com 1000W de puro grave, a Attack VRS-1810A entrega um reforço sonoro profundo e impactante, essencial para envolver seus convidados em eventos de médio a grande porte. Experimente a excelência na reprodução de baixas frequências, garantindo que cada batida seja sentida, da pista de dança ao palco.",
  },
  {
    id: "SOM02",
    categoria: "SOM",
    nome: 'Caixa de Grave Passiva 18" 800W \nAttack VRS-1880',
    preco: 300,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/caixa-grave-attack-vrs1880.jpg",
    descricao:
      "Para quem busca graves que realmente fazem a diferença, a Attack VRS-1880 é a escolha inteligente. Com 800W de potência passiva, ela complementa seu sistema de som, especialmente quando utilizada com a ativa VRS-1810A, criando uma experiência sonora imersiva com graves profundos e bem definidos. Amplie a intensidade sonora do seu evento e deixe a música envolver a todos.",
  },
  {
    id: "SOM03",
    categoria: "SOM",
    nome: 'Caixa de Grave Ativa 15" 800W \nOversound',
    preco: 250,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/caixa-grave-oversound-15.jpg",
    descricao:
      "Graves potentes e prontos para uso! A Caixa de Grave Ativa 15'' Oversound entrega 800W de potência com amplificação interna, dispensando o uso de módulos externos. Perfeita para reforçar as baixas frequências em eventos de médio e grande porte, oferece resposta profunda e definida, garantindo impacto sonoro sem perder a clareza. Ideal para DJs, bandas e sonorizações profissionais que precisam de praticidade e desempenho, sua construção robusta assegura confiabilidade mesmo nas condições mais exigentes.",
  },
  {
    id: "SOM04",
    categoria: "SOM",
    nome: 'Caixa de Grave Passiva 15" 800W \nOversound',
    preco: 250,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/caixa-grave-oversound-15.jpg",
    descricao:
      "Potência e presença para reforçar os graves do seu evento! A Caixa de Grave Passiva 15'' Oversound oferece 800W de capacidade, garantindo resposta firme nas frequências baixas e sustentação para qualquer sistema de som. Ideal para complementar caixas ativas ou ser usada em conjunto com amplificadores potentes, é perfeita para shows, festas e eventos que exigem um grave encorpado sem abrir mão da definição. Com construção robusta, é uma escolha confiável para sonorizações profissionais de médio porte. Ideal para utilizar em conjunto com a Caixa de Grave 15'' da Oversound.",
  },
  {
    id: "SOM05",
    categoria: "SOM",
    nome: 'Caixa Ativa 15" 500W \nAttack VRF-1550A',
    preco: 250,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/caixa-ativa-attack-vrf1550a.jpg",
    descricao:
      "A Attack VRF-1550A é a solução sonora completa para seus eventos de médio porte. Com 500W de potência ativa, ela oferece uma resposta sonora equilibrada, com médios definidos e graves presentes, garantindo que a música e a voz cheguem com clareza a todos os cantos. Versatilidade e eficiência em um único equipamento para uma experiência sonora impecável.",
  },
  {
    id: "SOM06",
    categoria: "SOM",
    nome: 'Caixa Passiva 15" 500W \nAttack VRF-1530',
    preco: 250,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/caixa-passiva-attack-vrf1530.jpg",
    descricao:
      'Construída para performance e durabilidade, a Caixa Passiva 15" Attack VRF-1530 oferece uma excelente dispersão sonora, preenchendo o ambiente com áudio de qualidade. Ideal para integrar seu sistema com amplificadores ou em conjunto com a ativa VRF-1550A, proporcionando um som robusto e envolvente para o seu evento.',
  },
  {
    id: "SOM07",
    categoria: "SOM",
    nome: 'Caixa Ativa 15" 1000W \nYamaha DBR-15',
    preco: 300,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/yamaha-dbr15.jpg",
    descricao:
      "A força e clareza da Yamaha agora com graves mais encorpados! A DBR-15 entrega 1000W de potência ativa e um woofer de 15 polegadas, oferecendo resposta de frequência estendida e mais pressão sonora nos graves em comparação à DBR-12. Ideal para eventos de médio e grande porte, palcos ao ar livre ou situações onde a música precisa de impacto e presença nas baixas frequências. Enquanto a DBR-12 é perfeita para ambientes fechados e foco em clareza vocal, a DBR-15 brilha quando a prioridade é potência, alcance e graves profundos sem perder a fidelidade do som.",
  },
  {
    id: "SOM08",
    categoria: "SOM",
    nome: 'Caixa Ativa 12" 1000W \nYamaha DBR-12',
    preco: 250,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/yamaha-dbr12.jpg",
    descricao:
      "Experimente a renomada qualidade sonora Yamaha com a DBR-12. Com 1000W de potência ativa, esta caixa é sinônimo de clareza e fidelidade na reprodução de áudio. Se a sua prioridade são vocais nítidos e instrumentos bem definidos, a DBR-12 é a escolha confiável para garantir uma experiência sonora profissional em seu evento.",
  },
  {
    id: "SOM09",
    categoria: "SOM",
    nome: 'Retorno Ativo 12" 300W \nAttack VRM-1230A',
    preco: 200,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/retorno-ativo-attack-vrm1230a.jpg",
    descricao:
      'Garanta que cada artista se ouça com perfeita clareza no palco! O Retorno Ativo 12" Attack VRM-1230A, com seus 300W de potência, oferece a definição sonora essencial para vocalistas e instrumentistas performarem com confiança. Um monitor robusto e eficiente para palcos e ensaios de todos os níveis.',
  },
  {
    id: "SOM10",
    categoria: "SOM",
    nome: 'Retorno Passivo 12" 300W \nAttack VRM-1220',
    preco: 200,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/retorno-passivo-attack-vrm1220.jpg",
    descricao:
      'Para um monitoramento de palco confiável e consistente, o Retorno Passivo 12" Attack VRM-1220 é a solução ideal. Com performance estável e a flexibilidade de uso com amplificadores externos ou integrado ao seu sistema ativo (VRM-1230A), ele garante que os artistas tenham um feedback sonoro preciso durante toda a apresentação.',
  },
  {
    id: "SOM11",
    categoria: "SOM",
    nome: "Sistema de Som Torre \nElectro-Voice Evolve30M",
    preco: 400,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/evolve30m.jpg",
    descricao:
      "Leve a potência sonora com você! O Sistema de Som Torre Electro-Voice Evolve30M combina um som potente e de alta qualidade com uma portabilidade incrível. Com mixer integrado e Bluetooth, ele é a solução completa e prática para eventos onde a facilidade de transporte e a qualidade sonora são cruciais. Prepare-se para um som que preenche o ambiente sem complicação. Esse valor corresponde a uma unidade do conjunto (1 Subwoofer + 1 Conjunto de alto falantes para médio e agudos)",
  },

  {
    id: "MIC01",
    categoria: "MICROFONES",
    nome: "Par de microfones sem fio \nArmer AX-802m",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/microfone-armer-ax802m.jpg",
    descricao:
      "Liberdade de movimento com qualidade de áudio impecável! O Par de Microfones Sem Fio Armer AX-802m oferece ótimo alcance e clareza vocal, essenciais para cerimônias emocionantes, apresentações impactantes e eventos corporativos profissionais. Garanta que cada palavra seja ouvida com nitidez e sem interferências.",
  },
  {
    id: "MIC02",
    categoria: "MICROFONES",
    nome: "Par de microfones sem fio \nKadosh K482m",
    preco: 125,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/microfone-kadosh-k482m.jpg",
    descricao:
      "Para quem busca confiabilidade e simplicidade, o Par de Microfones Sem Fio Kadosh K482m é a escolha certa. Fácil de usar e com transmissão estável, ele é perfeito para eventos casuais e profissionais leves, garantindo que sua voz seja amplificada com clareza e sem complicações.",
  },
   {
    id: "MIC10",
    categoria: "MICROFONES",
    nome: "Microfone Shure SLXD4D\n Capsula SM58 \n2 Bastões + Receptor",
    preco: 500,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/shureslxd4d.png",
    descricao:
      "Garanta um áudio impecável e a confiabilidade que seu evento merece! O sistema sem fio digital Shure SLXD oferece transmissão de alta qualidade, proporcionando voz cristalina, baixa latência e excelente estabilidade de sinal, mesmo em ambientes com grande concentração de equipamentos sem fio. Equipado com a lendária cápsula Shure SM58, referência mundial para vocais, entrega excelente presença, clareza e resistência, sendo a escolha de artistas e profissionais do áudio em todo o mundo. \nIdeal para palestras, cerimônias, eventos corporativos, igrejas, bandas e shows, o Shure SLXD combina tecnologia avançada, alcance confiável e operação simples para garantir máxima segurança durante toda a apresentação. \nConte com a qualidade Shure para elevar o nível sonoro do seu evento e proporcionar uma experiência profissional ao seu público.",
  },
    {
    id: "MIC11",
    categoria: "MICROFONES",
    nome: "Microfone Shure SLXD4D\n Capsula SM58 \n1 Bastão + Receptor",
    preco: 300,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/shureslxd4simples.png",
    descricao:
      "Garanta um áudio impecável e a confiabilidade que seu evento merece! O sistema sem fio digital Shure SLXD oferece transmissão de alta qualidade, proporcionando voz cristalina, baixa latência e excelente estabilidade de sinal, mesmo em ambientes com grande concentração de equipamentos sem fio. Equipado com a lendária cápsula Shure SM58, referência mundial para vocais, entrega excelente presença, clareza e resistência, sendo a escolha de artistas e profissionais do áudio em todo o mundo. \nIdeal para palestras, cerimônias, eventos corporativos, igrejas, bandas e shows, o Shure SLXD combina tecnologia avançada, alcance confiável e operação simples para garantir máxima segurança durante toda a apresentação. \nConte com a qualidade Shure para elevar o nível sonoro do seu evento e proporcionar uma experiência profissional ao seu público.",
  },

  {
    id: "MIC12",
    categoria: "MICROFONES",
    nome: "Microfone Headset \nArmer AX802HH",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/microfonearmerheadsetax802hh.png",
    descricao:
      "O Microfone Headset Armer AX802HH é uma solução prática e confortável para apresentações, palestras, treinamentos, cerimônias e eventos corporativos. Com captação clara da voz e design leve, proporciona liberdade de movimento ao usuário sem comprometer a qualidade do áudio, sendo ideal para quem precisa se comunicar com praticidade e excelente inteligibilidade.",
  },
  {
    id: "MIC03",
    categoria: ["MICROFONES", "PRODUÇÃO CONTEÚDO"],
    nome: "Microfone Lapela \nHollyland Lark M2 Combo Duo",
    preco: 80,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/larkm2.png",
    descricao:
      "Grave com liberdade e clareza excepcional! O Microfone Hollyland Lark M2 Combo Duo é um sistema de microfones sem fio compacto e de alta qualidade, ideal para entrevistas, gravações de vídeos, podcasts e eventos ao vivo. Com transmissão estável, baixa latência e som nítido, ele oferece mobilidade total e praticidade para captar áudio profissional em qualquer ambiente. Acompanha dois transmissores, um receptor e estojo de recarga.",
  },
  {
    id: "MIC04",
    categoria: ["MICROFONES", "PRODUÇÃO CONTEÚDO"],
    nome: "Microfone Lapela \nDJI Mic Mini",
    preco: 90,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/djimicmini.png",
    descricao:
      "O DJI Mic Mini é um sistema de microfone sem fio profissional, ideal para gravações de vídeo, entrevistas, palestras, eventos corporativos, produções de conteúdo e transmissões ao vivo. Com captação de áudio de alta qualidade, conexão estável e design compacto, proporciona liberdade de movimento e excelente clareza na voz, garantindo gravações com som limpo e confiável em diversas aplicações.",
  },
  {
    id: "MIC05",
    categoria: ["MICROFONES", "PRODUÇÃO CONTEÚDO"],
    nome: "Microfone Lapela \nLuucco Airwave K2",
    preco: 60,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/microfonelapelaluucco.png",
    descricao:
      "O Luucco Airwave K2 é um sistema de microfone sem fio compacto, ideal para gravações, entrevistas, eventos corporativos, produções de conteúdo e transmissões ao vivo. Com captação clara da voz, transmissão estável e design prático, oferece mobilidade e qualidade de áudio para diferentes aplicações profissionais.",
  },
  {
    id: "MIC06",
    categoria: "MICROFONES",
    nome: "Microfone Condensador \nBlue Yeti",
    preco: 70,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/blueyeti.png",
    descricao:
      "Alta qualidade sonora com simplicidade e estilo! O Microfone Condensador Blue Yeti é referência em captação de voz para podcasts, streaming, locuções e gravações musicais. Com múltiplos padrões de captação (cardioide, omnidirecional, bidirecional e estéreo), ele se adapta a diferentes situações com precisão e riqueza de detalhes. Conexão USB plug and play, design robusto e controle direto de ganho e monitoramento fazem dele a escolha ideal para quem busca qualidade profissional sem complicação.",
  },
  {
    id: "MIC07",
    categoria: "MICROFONES",
    nome: "Kit Microfones Bateria \nShure DMK 57-52",
    preco: 500,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/dmk57-52.png",
    descricao:
      "O Kit de Microfones Shure DMK 57-52 é uma solução profissional para microfonação de baterias e instrumentos de percussão. O kit é composto por 1 Shure Beta 52A, ideal para bumbo e instrumentos de baixa frequência, e 3 Shure SM57, reconhecidos mundialmente pela excelente captação de caixas, tons, amplificadores e outros instrumentos. Com alta durabilidade, qualidade sonora e confiabilidade, é a escolha ideal para shows, gravações, eventos corporativos e apresentações ao vivo.",
  },
  {
    id: "MIC08",
    categoria: "MICROFONES",
    nome: "Microfone Shure \nSM57",
    preco: 150,
    max: 3,
    imagem: process.env.PUBLIC_URL + "/images/sm57.png",
    descricao:
      "O Shure SM57 é um microfone dinâmico profissional, referência mundial na captação de instrumentos e amplificadores, além de ser amplamente utilizado para voz em aplicações ao vivo. Reconhecido por sua durabilidade, excelente rejeição a ruídos e reprodução sonora precisa, é a escolha ideal para microfonar caixas de bateria, caixas de guitarra, instrumentos de sopro, percussão e diversas outras aplicações em shows, eventos corporativos e gravações.",
  },
  {
    id: "MIC09",
    categoria: "MICROFONES",
    nome: "Microfone Shure \nBeta 52-A",
    preco: 200,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/beta-52a.jpg",
    descricao:
      "O Shure Beta 52-A é um microfone dinâmico profissional, especializado em captação de bumbo e instrumentos de baixa frequência. Reconhecido por sua durabilidade, excelente rejeição a ruídos e reprodução sonora precisa, é a escolha ideal para microfonar bumbo, surdos, baixos e outros instrumentos que exigem presença e impacto nas frequências graves.",
  },
 

  {
    id: "MIX01",
    categoria: "MESAS DE SOM",
    nome: "Mesa de Som Analógica \nYamaha MG16XU (16 canais)",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/Yamaha-MG16XU.jpg",
    descricao:
      "Mesa robusta e confiável para eventos que exigem múltiplas entradas. Conta com 10 pré-amplificadores de microfone com phantom power, efeitos digitais SPX integrados, interface USB para gravação/streaming e construção durável. Ideal para bandas, DJs e eventos ao vivo que precisam de controle preciso de som. Contém 4 saídas auxiliares.",
  },
  {
    id: "MIX02",
    categoria: "MESAS DE SOM",
    nome: "Mesa de Som Analógica \nBehringer Xenyx 802 (6 canais)",
    preco: 100,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/mesabehringer.png",
    descricao:
      "A Mesa de Som Behringer Xenyx 802 é uma mesa de áudio compacta e versátil, ideal para pequenas sonorizações, eventos corporativos, palestras, reuniões, transmissões e apresentações. Equipada com pré-amplificadores XENYX de alta qualidade, oferece excelente clareza sonora, controle preciso dos níveis de áudio e conexões para microfones e equipamentos de linha, garantindo praticidade e desempenho em diversas aplicações.",
  },

  {
    id: "DJ01",
    categoria: "DJ",
    nome: "Controladora DJ \nPioneer DDJ-400",
    preco: 200,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/pioneer-ddj400.jpg",
    descricao:
      "Comece sua jornada no mundo do DJing com a ferramenta perfeita! A Controladora Pioneer DDJ-400 oferece uma interface intuitiva e amigável, ideal para DJs iniciantes e intermediários explorarem sua criatividade. A compatibilidade nativa com o software Rekordbox facilita o aprendizado e a performance, colocando você no controle da festa em instantes.",
  },
  {
    id: "DJ02",
    categoria: "DJ",
    nome: "Controladora DJ \nPioneer XDJ-RX3",
    preco: 450,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/xdj-rx3.jpg",
    descricao:
      "Potência e praticidade em um único equipamento! A Pioneer XDJ-RX3 é uma controladora all-in-one que une versatilidade, portabilidade e performance profissional. Com tela sensível ao toque de 10,1 polegadas de alta resolução, oferece navegação intuitiva e visualização detalhada das faixas, tornando a mixagem mais fluida e criativa. Compatível com Rekordbox e Serato DJ Pro, ela combina a experiência de CDJs e mixers de alto nível em um setup compacto, perfeito para eventos, clubes e estúdios. Um equipamento que entrega qualidade sonora de ponta, recursos avançados e a confiabilidade que todo DJ precisa para dominar qualquer pista.",
  },
  {
    id: "DJ03",
    categoria: "DJ",
    nome: "Mixer DJ \nPioneer DJM-900NXS2",
    preco: 300,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/pioneer-djm900nxs2.jpg",
    descricao:
      "Eleve seu set a um novo patamar com a mesa de som profissional Pioneer DJM-900NXS2. Reconhecida como padrão em grandes eventos e clubes internacionais, ela oferece desempenho de ponta e recursos avançados para DJs que buscam a máxima qualidade sonora e controle total sobre a mixagem. Prepare-se para dominar a pista com uma ferramenta lendária.",
  },
  {
    id: "DJ04",
    categoria: "DJ",
    nome: "CDJ Pioneer DJ \nXDJ-1000MK2",
    preco: 200,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/pioneer-xdj1000mk2.jpg",
    descricao:
      "Explore novas possibilidades criativas com o controlador profissional Pioneer XDJ-1000MK2. Sua tela sensível ao toque intuitiva, o suporte completo ao software Rekordbox e a excelente resposta dos controles proporcionam uma experiência de performance fluida e precisa. Leve sua arte a um novo nível com um equipamento projetado para os DJs mais exigentes.",
  },
  {
    id: "DJ05",
    categoria: "DJ",
    nome: "Setup 1 DJ:\n1 DJM-900NXS2 + 2x XDJ-1000MK2",
    preco: 600,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/setup-dj-completo.jpg",
    descricao:
      "O arsenal definitivo para o DJ profissional! Este setup completo inclui a mesa de som Pioneer DJM-900NXS2 e dois controladores XDJ-1000MK2, o padrão de excelência em clubes e grandes eventos ao redor do mundo. Desfrute de performance incomparável, qualidade sonora superior e integração perfeita para criar sets inesquecíveis e dominar qualquer pista.",
  },
  {
    id: "DJ06",
    categoria: "DJ",
    nome: "Toca Discos \nTechnics SL1200 MK2",
    preco: 400,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/sl1200mk2.png",
    descricao:
      "O clássico absoluto da discotecagem! O Technics SL-1200MK2 é referência mundial quando se fala em toca-discos profissionais. Reconhecido pela durabilidade, precisão no pitch e torque poderoso, tornou-se o favorito de DJs em clubes, rádios e batalhas de turntablism. Um ícone que atravessa gerações, garantindo confiabilidade, controle total e a verdadeira essência do vinil na pista.",
  },
  {
    id: "DJ07",
    categoria: "DJ",
    nome: "Par de Toca Discos \nTechnics SL1200 MK2",
    preco: 700,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/parsl1200mk2.png",
    descricao:
      "O setup lendário que marcou a história do DJing! Este par de Technics SL-1200MK2 entrega robustez, precisão e confiabilidade incomparáveis, sendo a escolha definitiva para DJs de vinil ao redor do mundo. Com controle de pitch preciso, torque potente e construção durável, oferece a performance clássica que moldou gerações nas pistas e batalhas. Um kit essencial para quem busca a verdadeira experiência analógica e a energia autêntica do vinil.",
  },
  {
    id: "DJ08",
    categoria: "DJ",
    nome: "Par de Toca Discos \nTechnics SL1200 MK2 & Mixer DJM-900 NXS2",
    preco: 900,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/setup3.png",
    descricao:
      "O equilíbrio perfeito entre tradição e tecnologia! Este setup reúne a mesa de som Pioneer DJM-900NXS2, padrão internacional em clubes, com dois toca-discos Technics SL-1200MK2, referência absoluta para DJs de vinil. Uma combinação lendária que entrega qualidade sonora premium, confiabilidade extrema e total controle criativo para performances que unem a essência do analógico ao poder de um mixer profissional. Ideal para DJs que querem marcar presença com sets únicos e cheios de identidade.",
  },

  {
    id: "LUZ02",
    categoria: "ILUMINAÇÃO",
    nome: "Moving-Head 100W",
    preco: 100,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/movinghead100w.png",
    descricao:
      "O Moving Beam Head 100W 7 Gobo 7 Color com Prisma é um equipamento de iluminação profissional ideal para criar efeitos visuais impactantes em festas, shows, eventos corporativos, casamentos e formaturas. Com feixe de luz concentrado, gobos, cores variadas e efeito prisma, proporciona movimentos dinâmicos, desenhos de luz e composições cênicas que valorizam o ambiente e elevam a experiência visual do evento.",
  },
  {
    id: "LUZ03",
    categoria: "ILUMINAÇÃO",
    nome: "Moving Head RGB \n230W Mini 7R",
    preco: 150,
    max: 4,
    imagem: process.env.PUBLIC_URL + "/images/moving_head_mini_7r.png",
    descricao:
      "Impacto visual de verdade, do palco à pista! O Moving Head Mini 7R 230W entrega feixes intensos, cortes definidos e movimentos rápidos que transformam qualquer ambiente em um show de luz. O anel de LED adiciona um efeito extra de presença e “aura” no equipamento, criando composições modernas e chamativas mesmo quando o beam não está no máximo. Totalmente controlável via DMX, ele permite programar cenas, cores e efeitos com precisão — perfeito para festas, eventos corporativos e pistas que pedem energia, dinâmica e aquele visual profissional de clube.",
  },

  {
    id: "LUZ05",
    categoria: "ILUMINAÇÃO",
    nome: "Refletor Parled Quadriled \nRGBW 270W",
    preco: 50,
    max: 8,
    imagem: process.env.PUBLIC_URL + "/images/refletor-quadriled.jpg",
    descricao:
      "Potência e versatilidade para iluminar grandes espaços com qualidade profissional! O Refletor Parled Quadriled RGBW 270W combina alta intensidade luminosa com tecnologia RGBW, oferecendo um espectro ainda mais completo de cores. Ideal para palcos, eventos corporativos e festas que exigem impacto visual. Compatível com mesa DMX, permite controle preciso de cores, brilho e efeitos.",
  },
  {
    id: "LUZ07",
    categoria: "ILUMINAÇÃO",
    nome: "Refletor Parled Hexaled \nRGBWA+UV 324W",
    preco: 50,
    max: 10,
    imagem: process.env.PUBLIC_URL + "/images/refletorhexaled.png",
    descricao:
      "Alta potência e ampla variedade de cores para uma iluminação profissional e versátil! O Refletor Parled Hexalde RGBWA+UV 324W combina LEDs RGB, branco, âmbar e ultravioleta, permitindo criar tons mais ricos, cores quentes, efeitos vibrantes e iluminação UV. Ideal para casamentos, festas, eventos corporativos, palcos e ambientações decorativas. Compatível com controle DMX, oferece ajuste preciso de cores, intensidade, strobo e efeitos, garantindo excelente impacto visual em diferentes tipos de evento.",
  },
  {
    id: "LUZ08",
    categoria: "ILUMINAÇÃO",
    nome: "Ribalta Triled RGB \n24 Leds x 12W",
    preco: 60,
    max: 6,
    imagem: process.env.PUBLIC_URL + "/images/ribalta.png",
    descricao:
      "Ilumine com impacto e criatividade! A Ribalta 24 LEDs 12W RGBW oferece controle individual por pixel e tecnologia RGBW, permitindo efeitos de chase, strobe e gradações suaves de cor. Ideal para ambientação de palcos, paredes e elementos cênicos em eventos indoor. Compatível com DMX, é uma excelente escolha para quem busca versatilidade, potência e estética profissional na iluminação.",
  },

    {
    id: "LUZ09",
    categoria: "ILUMINAÇÃO",
    nome: "Strobo Atomic 1800W Power Pro",
    preco: 100,
    max: 6,
    imagem: process.env.PUBLIC_URL + "/images/strobo.png",
    descricao:
      "Impacto visual intenso para momentos de alta energia! O Strobo Atomic 1800W Power Pro oferece flashes de alta potência e grande alcance, ideal para criar efeitos marcantes em pistas de dança, shows, festas, palcos e eventos de grande porte. Com controle via DMX, permite ajustar a frequência e a intensidade dos disparos, possibilitando desde flashes pontuais até sequências rápidas e efeitos sincronizados com a iluminação do evento. Uma excelente escolha para valorizar drops, entradas, apresentações e momentos especiais com um efeito visual de grande impacto.",
  },
  


  {
    id: "LUZ10",
    categoria: "ILUMINAÇÃO",
    nome: "Laser RGB 3.3W",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/laser3.3w.png",
    descricao:
      "O Laser 3.3W SOG é um equipamento de iluminação profissional de alta potência, ideal para criar efeitos visuais impactantes em shows, festas, eventos corporativos, casamentos, formaturas e apresentações. Com feixes intensos e alta precisão, proporciona um espetáculo de luzes dinâmico, valorizando qualquer produção e elevando a experiência do público.",
  },
  {
    id: "LUZ11",
    categoria: "ILUMINAÇÃO",
    nome: "Refletor Parled COB \n200W Branco Quente e Branco Frio",
    preco: 100,
    max: 4,
    imagem: process.env.PUBLIC_URL + "/images/parled_cob_200w.png",
    descricao:
      "Potência, definição e elegância em uma única fonte de luz! O Par LED COB 200W entrega iluminação intensa e homogênea, com feixe limpo e sem sombras indesejadas, ideal para valorizar palcos, fachadas, painéis e ambientações sofisticadas. A tecnologia COB garante maior eficiência luminosa e cores mais consistentes, proporcionando um visual profissional tanto para eventos corporativos quanto para festas e shows. Totalmente controlável via DMX, permite ajustes precisos de intensidade e efeitos, elevando o nível da iluminação do seu evento com impacto e qualidade.",
  },
  {
    id: "LUZ12",
    categoria: "ILUMINAÇÃO",
    nome: "Mini Brut \n400W Branco Quente e Branco Frio",
    preco: 150,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/mini_brut_400w.png",
    descricao:
      "Explosão de luz e presença cênica imediata! O Mini Brut 400W entrega altíssima intensidade luminosa, criando aquele efeito clássico e poderoso que chama atenção à primeira olhada. Ideal para momentos de impacto, entradas triunfais, efeitos de clímax e iluminação frontal agressiva, ele adiciona força visual e personalidade ao palco e à pista. Com acionamento simples e resposta instantânea, é a escolha perfeita para quem busca um visual marcante, enérgico e com estética de grandes shows e eventos profissionais.",
  },
    {
    id: "LUZ13",
    categoria: "ILUMINAÇÃO",
    nome: "Ribalta Pimbim Tx \n 6x20W Branco Quente",
    preco: 200,
    max: 4,
    imagem: process.env.PUBLIC_URL + "/images/ribaltapimbim.png",
    descricao:
      "Iluminação elegante e precisa para valorizar ambientes, cenários e elementos decorativos! A Ribalta Pimbim TX 6x20W conta com LEDs em branco quente, proporcionando uma luz agradável e sofisticada, ideal para casamentos, eventos corporativos, palcos, fachadas, painéis e ambientação cênica. Seu ajuste de zoom permite controlar a abertura do facho de luz, possibilitando desde uma iluminação mais concentrada até uma cobertura mais ampla. Compatível com controle DMX, oferece versatilidade e excelente acabamento visual para diferentes aplicações.",
  },
  {
    id: "LUZ14",
    categoria: ["ILUMINAÇÃO", "PRODUÇÃO CONTEÚDO"],
    nome: "Iluminador Key Light \nSokani P25",
    preco: 80,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/iluminador-sokani.png",
    descricao:
      "Iluminação profissional na medida certa! O Sokani Key Light P25 oferece brilho poderoso e controle total da temperatura de cor, ideal para gravações, entrevistas, transmissões ao vivo e fotografia. Com ajuste de 2800K a 8000K e alto índice de reprodução de cor (CRI 96+), garante tons naturais e realistas em qualquer ambiente. Compacto e leve, pode ser usado em tripé, câmera ou diretamente sobre mesas de produção. Alimentado por bateria ou energia direta, é perfeito para quem busca praticidade e qualidade de estúdio em formato portátil.",
  },
  {
    id: "LUZ15",
    categoria: "ILUMINAÇÃO",
    nome: "Máquina de Fumaça 2000W",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/maquina-fumaca-2000w.jpg",
    descricao:
      "Crie uma atmosfera mágica e intensifique os efeitos de iluminação do seu evento com a Máquina de Fumaça 2000W. Essencial para envolver seus convidados e dar um toque especial à pista de dança ou ao palco. Totalmente controlável via mesa DMX, permitindo sincronizar a fumaça com o ritmo da música e os efeitos de luz.",
  },
  {
    id: "LUZ16",
    categoria: "ILUMINAÇÃO",
    nome: "Globo Espelhado \n30cm",
    preco: 50,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/globo_espelhado.png",
    descricao:
      "Um clássico atemporal que nunca sai de cena! O Globo Espelhado de 30 cm transforma qualquer ambiente em uma pista vibrante e cheia de movimento, refletindo a luz em centenas de pontos que se espalham pelo espaço. Ideal para criar clima retrô, disco ou simplesmente adicionar dinamismo e charme à iluminação do evento. Quando combinado com refletores ou spots direcionados, entrega um efeito visual envolvente, elegante e nostálgico, perfeito para festas, pistas de dança e momentos especiais.",
  },
  {
    id: "LUZ17",
    categoria: "ILUMINAÇÃO",
    nome: "Mesa DMX Operator 512 canais",
    preco: 50,
    max: 3,
    imagem: process.env.PUBLIC_URL + "/images/mesa-dmx-operator.jpg",
    descricao:
      "Assuma o controle total da sua iluminação profissional com a Mesa DMX Operator de 512 canais. Uma ferramenta essencial para gerenciar e sincronizar diversos equipamentos de luz, permitindo criar shows de iluminação complexos e impressionantes. Liberte sua criatividade e transforme seu evento em um espetáculo visual!",
  },

  {
    id: "VID01",
    categoria: "VÍDEO",
    nome: "Projetor Acer \nX1328WH - 5000 ANSI LUMENS",
    preco: 350,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/projetor-acer.png",
    descricao:
      "Imagens brilhantes e nítidas em qualquer ambiente! O Projetor Acer X1328WH entrega 5000 ANSI Lumens de potência luminosa, garantindo projeções claras mesmo em locais com iluminação ambiente. Com resolução nativa HD e tecnologia ColorBoost3D, oferece cores vibrantes e contrastes precisos, ideais para apresentações, eventos corporativos, projeções de vídeo e festas com painéis ou telões. Compacto e fácil de configurar, é a escolha perfeita para quem busca qualidade visual profissional e desempenho confiável.",
  },
  {
    id: "VID02",
    categoria: "VÍDEO",
    nome: "Tela de Projeção \n120 polegadas",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/tela-de-projeção.png",
    descricao:
      "Transforme qualquer ambiente em uma verdadeira sala de cinema! A Tela de Projeção Tripé de 120 polegadas oferece ampla área de visualização no formato widescreen 16:9, ideal para filmes, apresentações e eventos. Seu tecido dupla face retrátil proporciona excelente definição de imagem, com alto contraste e brilho uniforme — perfeita para projeções frontais ou traseiras. Leve e portátil, acompanha sacola para transporte e montagem prática, sendo a escolha ideal para uso profissional, corporativo ou lazer ao ar livre. Compacta, resistente e versátil, garante uma experiência visual imersiva em qualquer lugar.",
  },
  {
    id: "VID03",
    categoria: "VÍDEO",
    nome: "Televisão TCL C6K \n65 Polegadas + Suporte de Piso",
    preco: 750,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/televisao65polegadas.jpg",
    descricao:
      "A Smart TV TCL C6K 65 Polegadas oferece imagem de alta definição, design moderno e excelente qualidade visual para eventos corporativos, palestras, feiras, treinamentos, exposições e apresentações. Com tela de 65 polegadas, resolução 4K e amplo ângulo de visão, proporciona uma experiência imersiva para exibição de vídeos, apresentações, transmissões e conteúdos multimídia, agregando sofisticação e praticidade a qualquer evento.",
  },
    {
    id: "VID04",
    categoria: "VÍDEO",
    nome: "Passador de slide \nLogitech R400",
    preco: 30,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/passadorslide.png",
    descricao:
      "Mais liberdade e profissionalismo para apresentações, palestras e eventos corporativos! O Passador de Slides Logitech R400 permite avançar e retornar apresentações à distância, proporcionando maior mobilidade ao apresentador durante o evento. Conta com apontador laser vermelho para destacar informações importantes na tela e conexão sem fio prática e confiável. Ideal para congressos, treinamentos, reuniões, palestras, workshops e apresentações empresariais.",
  },

  {
    id: "SUP01",
    categoria: "SUPORTES",
    nome: "Mesa Desmontável para DJ \nMaxchief 1,22m x 0,90m",
    preco: 50,
    max: 3,
    imagem: process.env.PUBLIC_URL + "/images/Mesa Desmontável.png",
    descricao:
      "Praticidade e estabilidade para qualquer evento! A Mesa Desmontável Maxchief de 1,22m é leve, resistente e fácil de montar e desmontar, ocupando pouco espaço no transporte. Sua altura é perfeita para DJs, oferecendo ergonomia ideal para manipulação de equipamentos e controle de som durante todo o evento. Versátil e robusta, é ideal para uso em festas, eventos corporativos, feiras e apresentações, garantindo um apoio seguro para notebooks, controladoras, mixers e outros equipamentos.",
  },
  {
    id: "SUP02",
    categoria: "SUPORTES",
    nome: "Pedestal para Microfone \nOn Stage MS-7701B",
    preco: 40,
    max: 4,
    imagem: process.env.PUBLIC_URL + "/images/pedestal-microfone.png",
    descricao:
      "Estabilidade e versatilidade para qualquer performance! O Pedestal de Microfone Profissional On-Stage MS-7701B é reconhecido pela robustez e praticidade no uso. Com base tripé dobrável e haste telescópica ajustável, ele permite posicionar o microfone com precisão, seja em palcos, estúdios ou eventos corporativos. Seu design leve e resistente garante fácil transporte e montagem rápida, enquanto o acabamento preto fosco confere um visual discreto e elegante. Ideal para vocalistas, palestrantes e músicos que exigem confiabilidade e ergonomia durante suas apresentações.",
  },
  {
    id: "SUP03",
    categoria: "SUPORTES",
    nome: "Pedestal para Microfone \nHunter TPH 55",
    preco: 40,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/pedestalbaby.png",
    descricao:
      "O Pedestal de Microfone para Bumbo Hunter TPH55 é uma solução robusta e compacta para posicionamento preciso de microfones em bumbos, amplificadores e outras aplicações de baixa altura. Com base reforçada, ajuste de altura e haste telescópica, oferece excelente estabilidade, praticidade na montagem e segurança durante shows, eventos corporativos, gravações e apresentações ao vivo.",
  },
  {
    id: "SUP04",
    categoria: "SUPORTES",
    nome: "Tripé para iluminação \nGreika FC-S288L 2,80m",
    preco: 40,
    max: 4,
    imagem: process.env.PUBLIC_URL + "/images/suporteiluminacao.png",
    descricao:
      "O Tripé de Iluminação Greika FC-S288L 2,80m é uma estrutura prática e resistente para montagem de refletores e outros equipamentos de iluminação. Produzido em aço inox, oferece boa estabilidade, ajuste de altura e segurança durante o uso, sendo ideal para festas, eventos corporativos, gravações, apresentações e montagens profissionais de pequeno e médio porte.",
  },
  {
    id: "SUP05",
    categoria: "SUPORTES",
    nome: "Suporte de Piso para TV \nNorth Bayou AVA 1500 \n32 a 70 polegadas",
    preco: 150,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/suportetv.png",
    descricao:
      "O Suporte para TV North Bayou AVA1500 é uma solução profissional para instalação de televisores em eventos, oferecendo segurança, estabilidade e excelente acabamento. Compatível com TVs de diversos tamanhos, possui estrutura robusta e design moderno, sendo ideal para palestras, feiras, estandes, eventos corporativos, treinamentos e apresentações que exigem praticidade e uma montagem elegante.",
  },
  {
    id: "SUP06",
    categoria: "SUPORTES",
    nome: "Suporte Porta Banner \n até 2,50 metros",
    preco: 40,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/bannertripe.jpg",
    descricao:
      "Praticidade e apresentação profissional para banners em eventos, feiras e ações promocionais! O Suporte Porta Banner com regulagem de altura de até 2,50 metros permite a exposição de banners de diferentes tamanhos de forma segura e organizada. Ideal para recepções, eventos corporativos, congressos, feiras, lançamentos, sinalização e comunicação visual. Sua estrutura ajustável facilita a montagem e o posicionamento, garantindo boa visibilidade e acabamento profissional ao ambiente",
  },


  {
    id: "AUD01",
    categoria: "ACESSÓRIOS AUDIO",
    nome: "Gravador Digital \nZoom H6",
    preco: 80,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/zoomh6.png",
    descricao:
      "Capture áudio com qualidade de estúdio em qualquer lugar! O Gravador Zoom H6 é uma solução portátil e versátil para gravações profissionais, com até 6 canais simultâneos, cápsulas intercambiáveis e entradas XLR/TRS. Ideal para entrevistas, produções musicais, podcasts e cobertura de eventos ao vivo. Com excelente qualidade de conversão e autonomia, o H6 garante registros sonoros claros e detalhados em qualquer situação.",
  },
  {
    id: "AUD02",
    categoria: "ACESSÓRIOS AUDIO",
    nome: "Direct Box \nBehringer DI100",
    preco: 40,
    max: 2,
    imagem: process.env.PUBLIC_URL + "/images/directboxbehringer.png",
    descricao:
      "O Direct Box Behringer DI100 é um direct box ativo profissional, ideal para conectar instrumentos, notebooks, mesas de DJ e outros equipamentos de áudio diretamente à mesa de som com máxima qualidade e segurança. Proporciona sinal balanceado, reduz interferências e ruídos, além de contar com isolamento por transformador e atenuação de sinal, sendo a escolha ideal para shows, eventos corporativos, apresentações e gravações.",
  },

  {
    id: "PROD01",
    categoria: "PRODUÇÃO CONTEÚDO",
    nome: "Estabilizador Gimbal \nDJI Osmo Mobile 8",
    preco: 170,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/djiosmomobile8.png",
    descricao:
      "O DJI Osmo Mobile 8 é um estabilizador de smartphone desenvolvido para capturar vídeos com movimentos suaves e aparência profissional. Leve, compacto e fácil de utilizar, oferece excelente estabilidade durante gravações em eventos, produções de conteúdo, entrevistas e transmissões ao vivo. É a solução ideal para registrar imagens de alta qualidade com maior fluidez e praticidade.",
  },
  {
    id: "PROD02",
    categoria: "PRODUÇÃO CONTEÚDO",
    nome: "Kit Gravação \nCreator On-The-Go",
    preco: 200,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/creatoronthego.png",
    descricao:
      "Produção de conteúdo com imagem estabilizada e áudio profissional diretamente pelo smartphone! O Kit Creator On-The-Go combina o Gimbal DJI Osmo Mobile 8P com o Microfone Hollyland Lark M2, proporcionando movimentos suaves de câmera e captação de voz com excelente qualidade. Ideal para Reels, entrevistas, vlogs, cobertura de eventos, vídeos institucionais e produção de conteúdo para redes sociais. Uma solução prática e portátil para elevar a qualidade das suas gravações sem a necessidade de uma estrutura complexa de filmagem.",
  },
  {
    id: "PROD03",
    categoria: "PRODUÇÃO CONTEÚDO",
    nome: "Kit Gravação \nCreator Content 360°",
    preco: 450,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/creatorcontet360.png",
    descricao:
      "Uma solução completa para produção de conteúdo do chão ao alto! O Setup Creator Content 360° reúne o Drone DJI Neo 2 Fly More, o Gimbal DJI Osmo Mobile 8P e o Microfone Hollyland Lark M2, oferecendo imagens aéreas, gravações estabilizadas com smartphone e captação de áudio profissional em um único kit. Ideal para mercado imobiliário, eventos, produtoras, turismo, vídeos institucionais e criação de conteúdo para redes sociais. Perfeito para quem busca maior variedade de enquadramentos e uma produção visual mais dinâmica e profissional.",
  },
   {
    id: "PROD04",
    categoria: "PRODUÇÃO CONTEÚDO",
    nome: "Drone DJI \nNeo 2 Fly More Combo ",
    preco: 300,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/dailyairpro.png",
    descricao:
      "Imagens aéreas para transformar a perspectiva das suas produções! O Kit Daily Air Pro conta com o Drone DJI Neo 2 Fly More Combo, oferecendo uma solução prática para criação de takes aéreos, movimentos dinâmicos e diferentes enquadramentos para vídeos e redes sociais. Ideal para eventos, imóveis, turismo, conteúdos institucionais e produções audiovisuais que buscam agregar imagens de alto impacto. O kit completo proporciona maior praticidade e autonomia para diferentes situações de gravação.",
  },
  {
    id: "TABLET01",
    categoria: "TABLETS",
    nome: "Tablet 12.1 pol. \nRedmi Pad Pro 8GB RAM 256GB",
    preco: 130,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/redmipadpro.png",
    descricao:
      "O Redmi Pad Pro 8GB + 256GB é um tablet de alto desempenho, ideal para controle de equipamentos, apresentações, monitoramento, produção de conteúdo e aplicações profissionais em eventos. Com tela ampla de alta resolução, excelente desempenho e grande capacidade de armazenamento, oferece praticidade, fluidez e confiabilidade para operar softwares, exibir conteúdos e gerenciar diferentes tarefas com eficiência.",
  },
  {
    id: "TABLET02",
    categoria: "TABLETS",
    nome: "Tablet 12.1n pol. \nRedmi Pad Pro + Caneta Redmi Smart Pen",
    preco: 160,
    max: 1,
    imagem: process.env.PUBLIC_URL + "/images/redmipadprocaneta.png",
    descricao:
      "O Redmi Pad Pro + Caneta é uma solução completa para apresentações, anotações, controle de equipamentos e produção de conteúdo em eventos. Com tela ampla de alta resolução, excelente desempenho e a precisão da caneta inteligente, proporciona uma experiência intuitiva para desenhar, escrever, destacar informações e operar aplicativos com agilidade. Ideal para palestras, treinamentos, projetos, assinaturas digitais e diversas aplicações profissionais.",
  },
];

export default equipamentos;